import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24",
  style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"}
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("animate", {
  attributeName: "r",
  begin: "0",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
  repeatCount: "indefinite",
  values: "0;2;0;0"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("animate", {
  attributeName: "r",
  begin: "0.125s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
  repeatCount: "indefinite",
  values: "0;2;0;0"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["fill"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("animate", {
  attributeName: "r",
  begin: "0.25s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
  repeatCount: "indefinite",
  values: "0;2;0;0"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["fill"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("animate", {
  attributeName: "r",
  begin: "0.375s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
  repeatCount: "indefinite",
  values: "0;2;0;0"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["fill"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("animate", {
  attributeName: "r",
  begin: "0.5s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
  repeatCount: "indefinite",
  values: "0;2;0;0"
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["fill"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("animate", {
  attributeName: "r",
  begin: "0.625s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
  repeatCount: "indefinite",
  values: "0;2;0;0"
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["fill"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("animate", {
  attributeName: "r",
  begin: "0.75s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
  repeatCount: "indefinite",
  values: "0;2;0;0"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["fill"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("animate", {
  attributeName: "r",
  begin: "0.875s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
  repeatCount: "indefinite",
  values: "0;2;0;0"
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as {
  color?: string;
}



const color = props.color || "#000";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("circle", {
      cx: "12",
      cy: "2",
      r: "0",
      fill: _unref(color)
    }, _hoisted_4, 8, _hoisted_2),
    _createElementVNode("circle", {
      cx: "12",
      cy: "2",
      r: "0",
      fill: _unref(color),
      transform: "rotate(45 12 12)"
    }, _hoisted_7, 8, _hoisted_5),
    _createElementVNode("circle", {
      cx: "12",
      cy: "2",
      r: "0",
      fill: _unref(color),
      transform: "rotate(90 12 12)"
    }, _hoisted_10, 8, _hoisted_8),
    _createElementVNode("circle", {
      cx: "12",
      cy: "2",
      r: "0",
      fill: _unref(color),
      transform: "rotate(135 12 12)"
    }, _hoisted_13, 8, _hoisted_11),
    _createElementVNode("circle", {
      cx: "12",
      cy: "2",
      r: "0",
      fill: _unref(color),
      transform: "rotate(180 12 12)"
    }, _hoisted_16, 8, _hoisted_14),
    _createElementVNode("circle", {
      cx: "12",
      cy: "2",
      r: "0",
      fill: _unref(color),
      transform: "rotate(225 12 12)"
    }, _hoisted_19, 8, _hoisted_17),
    _createElementVNode("circle", {
      cx: "12",
      cy: "2",
      r: "0",
      fill: _unref(color),
      transform: "rotate(270 12 12)"
    }, _hoisted_22, 8, _hoisted_20),
    _createElementVNode("circle", {
      cx: "12",
      cy: "2",
      r: "0",
      fill: _unref(color),
      transform: "rotate(315 12 12)"
    }, _hoisted_25, 8, _hoisted_23)
  ]))
}
}

})